import { AnyAction } from 'redux';
import { MyCpgPods, MyCpgPodsActions, MyCpgPodsState } from './mycpg-pod-models';



const InitialState: MyCpgPodsState =
{
	pods: null,
	podsError: false,
	podsLoaded: false,
};



export const myCpgPodReducer = (state = InitialState, action: AnyAction): MyCpgPodsState => {

	switch (action.type) {

		case MyCpgPodsActions.SET_MYCPG_PODS:
			return {
				...state,
				pods: action.payload,
				podsLoaded: true,
			};
		case MyCpgPodsActions.SET_MYCPG_ERROR:
			return {
				...state,
				podsError: true,
				podsLoaded: true,
			};
		default: return state;
	}
};



export const setPods = (pods: MyCpgPods) => {

	return {
		type: MyCpgPodsActions.SET_MYCPG_PODS,
		payload: pods,
	};
};

export const setPodsError = () => {

	return {
		type: MyCpgPodsActions.SET_MYCPG_ERROR,
	};
};